function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Arrow 2",
  d: "M2.5 13C1.39543 13 0.5 13.8954 0.5 15C0.5 16.1046 1.39543 17 2.5 17V13ZM43.9142 16.4142C44.6953 15.6332 44.6953 14.3668 43.9142 13.5858L31.1863 0.857864C30.4052 0.0768156 29.1389 0.0768156 28.3579 0.857864C27.5768 1.63891 27.5768 2.90524 28.3579 3.68629L39.6716 15L28.3579 26.3137C27.5768 27.0948 27.5768 28.3611 28.3579 29.1421C29.1389 29.9232 30.4052 29.9232 31.1863 29.1421L43.9142 16.4142ZM2.5 17H42.5V13H2.5V17Z",
  fill: "#00013A"
});

var SvgRightArrow = function SvgRightArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 30,
    viewBox: "0 0 45 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRightArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/right-arrow.89de0c27.svg";
export { ForwardRef as ReactComponent };